import { RefreshCw, Zap, Crown, LogOut } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function CategorySidebar({
  categories, selected, onSelect, interval, onInterval,
  onRefresh, refreshing, fetchedAt, user, usage, onUpgrade, onLogout,
}) {
  return (
    <aside className="border-r border-border bg-white flex flex-col h-full">
      <div className="p-5 border-b border-border">
        <p className="font-mono text-[10px] tracking-[0.25em] uppercase text-muted-foreground mb-3">Categories</p>
        <nav className="space-y-1">
          {categories.map((c) => (
            <button
              key={c.id}
              data-testid={`category-${c.id}`}
              onClick={() => onSelect(c.id)}
              className={`w-full text-left px-3 py-2 text-sm font-medium transition-colors border ${
                selected === c.id
                  ? "bg-[#ffce00] text-black border-[#111110]"
                  : "bg-white text-foreground border-transparent hover:border-border"
              }`}
            >
              {c.label}
            </button>
          ))}
        </nav>
      </div>

      <div className="p-5 border-b border-border">
        <p className="font-mono text-[10px] tracking-[0.25em] uppercase text-muted-foreground mb-3">Auto-fetch</p>
        <div className="flex border border-border mb-3">
          {[15, 30].map((m) => (
            <button
              key={m}
              data-testid={`interval-${m}`}
              onClick={() => onInterval(m)}
              className={`flex-1 py-2 text-sm font-mono transition-colors ${
                interval === m ? "bg-[#111110] text-white" : "bg-white hover:bg-secondary"
              }`}
            >
              {m} min
            </button>
          ))}
        </div>
        <Button
          data-testid="fetch-now"
          onClick={onRefresh}
          disabled={refreshing}
          variant="outline"
          className="w-full rounded-none font-mono text-xs uppercase tracking-wider"
        >
          <RefreshCw className={`w-3.5 h-3.5 mr-2 ${refreshing ? "animate-spin" : ""}`} aria-hidden="true" />
          Fetch now
        </Button>
        {fetchedAt && (
          <p className="font-mono text-[10px] text-muted-foreground mt-2">
            Updated {new Date(fetchedAt).toLocaleTimeString()}
          </p>
        )}
      </div>

      <div className="mt-auto p-5 space-y-3">
        <div className="border border-border p-3">
          <div className="flex items-center justify-between mb-1">
            <span className="font-mono text-[10px] uppercase tracking-wider text-muted-foreground">Plan</span>
            <span
              data-testid="plan-badge"
              className={`font-mono text-[10px] px-2 py-0.5 uppercase ${
                usage?.premium ? "bg-[#111110] text-[#ffce00]" : "bg-secondary text-foreground"
              }`}
            >
              {usage?.premium ? "Premium" : "Free"}
            </span>
          </div>
          <p className="text-sm font-medium truncate">{user?.name}</p>
          <p className="text-xs text-muted-foreground truncate">{user?.email}</p>
          {!usage?.premium && (
            <>
              <p className="font-mono text-[11px] text-muted-foreground mt-2">
                {usage?.rewrites_used ?? 0}/{usage?.rewrites_limit} rewrites today
              </p>
              <Button
                data-testid="upgrade-btn"
                onClick={onUpgrade}
                className="w-full rounded-none mt-2 bg-[#ffce00] hover:bg-[#e6b900] text-[#111110] font-mono text-xs uppercase tracking-wider"
              >
                <Crown className="w-3.5 h-3.5 mr-2" aria-hidden="true" /> Upgrade $5
              </Button>
            </>
          )}
          {usage?.premium && (
            <p className="font-mono text-[11px] text-[#111110] mt-2 flex items-center gap-1">
              <Zap className="w-3 h-3" aria-hidden="true" /> Unlimited access
            </p>
          )}
        </div>
        <Button
          data-testid="logout-btn"
          onClick={onLogout}
          variant="ghost"
          className="w-full rounded-none font-mono text-xs uppercase tracking-wider text-muted-foreground"
        >
          <LogOut className="w-3.5 h-3.5 mr-2" aria-hidden="true" /> Sign out
        </Button>
      </div>
    </aside>
  );
}
